/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
export class ViewCompositionStartEvent {
  constructor() {
    this.type = 0 /* ViewCompositionStart */;
  }
}
export class ViewCompositionEndEvent {
  constructor() {
    this.type = 1 /* ViewCompositionEnd */;
  }
}
export class ViewConfigurationChangedEvent {
  constructor(source) {
    this.type = 2 /* ViewConfigurationChanged */;
    this._source = source;
  }
  hasChanged(id) {
    return this._source.hasChanged(id);
  }
}
export class ViewCursorStateChangedEvent {
  constructor(selections, modelSelections) {
    this.type = 3 /* ViewCursorStateChanged */;
    this.selections = selections;
    this.modelSelections = modelSelections;
  }
}
export class ViewDecorationsChangedEvent {
  constructor(source) {
    this.type = 4 /* ViewDecorationsChanged */;
    if (source) {
      this.affectsMinimap = source.affectsMinimap;
      this.affectsOverviewRuler = source.affectsOverviewRuler;
    } else {
      this.affectsMinimap = true;
      this.affectsOverviewRuler = true;
    }
  }
}
export class ViewFlushedEvent {
  constructor() {
    this.type = 5 /* ViewFlushed */;
    // Nothing to do
  }
}
export class ViewFocusChangedEvent {
  constructor(isFocused) {
    this.type = 6 /* ViewFocusChanged */;
    this.isFocused = isFocused;
  }
}
export class ViewLanguageConfigurationEvent {
  constructor() {
    this.type = 7 /* ViewLanguageConfigurationChanged */;
  }
}
export class ViewLineMappingChangedEvent {
  constructor() {
    this.type = 8 /* ViewLineMappingChanged */;
    // Nothing to do
  }
}
export class ViewLinesChangedEvent {
  constructor(fromLineNumber, toLineNumber) {
    this.type = 9 /* ViewLinesChanged */;
    this.fromLineNumber = fromLineNumber;
    this.toLineNumber = toLineNumber;
  }
}
export class ViewLinesDeletedEvent {
  constructor(fromLineNumber, toLineNumber) {
    this.type = 10 /* ViewLinesDeleted */;
    this.fromLineNumber = fromLineNumber;
    this.toLineNumber = toLineNumber;
  }
}
export class ViewLinesInsertedEvent {
  constructor(fromLineNumber, toLineNumber) {
    this.type = 11 /* ViewLinesInserted */;
    this.fromLineNumber = fromLineNumber;
    this.toLineNumber = toLineNumber;
  }
}
export class ViewRevealRangeRequestEvent {
  constructor(source, range, selections, verticalType, revealHorizontal, scrollType) {
    this.type = 12 /* ViewRevealRangeRequest */;
    this.source = source;
    this.range = range;
    this.selections = selections;
    this.verticalType = verticalType;
    this.revealHorizontal = revealHorizontal;
    this.scrollType = scrollType;
  }
}
export class ViewScrollChangedEvent {
  constructor(source) {
    this.type = 13 /* ViewScrollChanged */;
    this.scrollWidth = source.scrollWidth;
    this.scrollLeft = source.scrollLeft;
    this.scrollHeight = source.scrollHeight;
    this.scrollTop = source.scrollTop;
    this.scrollWidthChanged = source.scrollWidthChanged;
    this.scrollLeftChanged = source.scrollLeftChanged;
    this.scrollHeightChanged = source.scrollHeightChanged;
    this.scrollTopChanged = source.scrollTopChanged;
  }
}
export class ViewThemeChangedEvent {
  constructor() {
    this.type = 14 /* ViewThemeChanged */;
  }
}
export class ViewTokensChangedEvent {
  constructor(ranges) {
    this.type = 15 /* ViewTokensChanged */;
    this.ranges = ranges;
  }
}
export class ViewTokensColorsChangedEvent {
  constructor() {
    this.type = 16 /* ViewTokensColorsChanged */;
    // Nothing to do
  }
}
export class ViewZonesChangedEvent {
  constructor() {
    this.type = 17 /* ViewZonesChanged */;
    // Nothing to do
  }
}